﻿/*!
 * fi Series Web API JavaScript Library
 * Product: PFU Limited
 *
 * © PFU Limited 2018-2024
 * Version: 1.8.0.1
 */
(function() {

    window['ricoh'] = {
		fiscanner: {}
	}
	
    Object.defineProperty(ricoh.fiscanner, "adjustRGB", {
		get: function () {
			return fiHub.state.aRGB
		},
		set: function (v) {
			fiHub.state.aRGB = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "adjustRGBB", {
		get: function () {
			return fiHub.state.aRB
		},
		set: function (v) {
			fiHub.state.aRB = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "adjustRGBG", {
		get: function () {
			return fiHub.state.aRG
		},
		set: function (v) {
			fiHub.state.aRG = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "adjustRGBR", {
		get: function () {
			return fiHub.state.aRR
		},
		set: function (v) {
			fiHub.state.aRR = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "aDTCThreshold", {
		get: function () {
			return fiHub.state.aTho
		},
		set: function (v) {
			fiHub.state.aTho = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "aIQCNotice", {
		get: function () {
			return fiHub.state.aNo
		},
		set: function (v) {
			fiHub.state.aNo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "autoBorderDetection", {
		get: function () {
			return fiHub.state.aBD
		},
		set: function (v) {
			fiHub.state.aBD = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "autoBright", {
		get: function () {
			return fiHub.state.aBr
		},
		set: function (v) {
			fiHub.state.aBr = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "automaticColorBackground", {
		get: function () {
			return fiHub.state.aCB
		},
		set: function (v) {
			fiHub.state.aCB = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "automaticColorSensitivity", {
		get: function () {
			return fiHub.state.aCS
		},
		set: function (v) {
			fiHub.state.aCS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "automaticRotateMode", {
		get: function () {
			return fiHub.state.aRM
		},
		set: function (v) {
			fiHub.state.aRM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "automaticSenseMedium", {
		get: function () {
			return fiHub.state.aSM
		},
		set: function (v) {
			fiHub.state.aSM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "autoProfile", {
		get: function () {
			return fiHub.state.aPr
		},
		set: function (v) {
			fiHub.state.aPr = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "autoProfileSensitivity", {
		get: function () {
			return fiHub.state.aPS
		},
		set: function (v) {
			fiHub.state.aPS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "background", {
		get: function () {
			return fiHub.state.bGr
		},
		set: function (v) {
			fiHub.state.bGr = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "backgroundColor", {
		get: function () {
			return fiHub.state.bGrC
		},
		set: function (v) {
			fiHub.state.bGrC = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothing", {
		get: function () {
			return fiHub.state.bGrSi
		},
		set: function (v) {
			fiHub.state.bGrSi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothness", {
		get: function () {
			return fiHub.state.bGrSn
		},
		set: function (v) {
			fiHub.state.bGrSn = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "backgroundThreshold", {
		get: function () {
			return fiHub.state.bGrT
		},
		set: function (v) {
			fiHub.state.bGrT = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeDetection", {
		get: function () {
			return fiHub.state.bDe
		},
		set: function (v) {
			fiHub.state.bDe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeDirection", {
		get: function () {
			return fiHub.state.bDi
		},
		set: function (v) {
			fiHub.state.bDi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeMaxSearchPriorities", {
		get: function () {
			return fiHub.state.bMSP
		},
		set: function (v) {
			fiHub.state.bMSP = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeNotDetectionNotice", {
		get: function () {
			return fiHub.state.bNDN
		},
		set: function (v) {
			fiHub.state.bNDN = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeRegionLeft", {
		get: function () {
			return fiHub.state.bRLf
		},
		set: function (v) {
			fiHub.state.bRLf = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeRegionLength", {
		get: function () {
			return fiHub.state.bRLn
		},
		set: function (v) {
			fiHub.state.bRLn = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeRegionTop", {
		get: function () {
			return fiHub.state.bRTo
		},
		set: function (v) {
			fiHub.state.bRTo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeRegionWidth", {
		get: function () {
			return fiHub.state.bRW
		},
		set: function (v) {
			fiHub.state.bRW = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "barcodeType", {
		get: function () {
			return fiHub.state.bTy
		},
		set: function (v) {
			fiHub.state.bTy = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "binding", {
		get: function () {
			return fiHub.state.bId
		},
		set: function (v) {
			fiHub.state.bId = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "blankPageIgnoreAreaSize", {
		get: function () {
			return fiHub.state.bPIAS
		},
		set: function (v) {
			fiHub.state.bPIAS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "blankPageNotice", {
		get: function () {
			return fiHub.state.bPN
		},
		set: function (v) {
			fiHub.state.bPN = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "blankPageSkip", {
		get: function () {
			return fiHub.state.bPS
		},
		set: function (v) {
			fiHub.state.bPS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "blankPageSkipMode", {
		get: function () {
			return fiHub.state.bPSM
		},
		set: function (v) {
			fiHub.state.bPSM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "blankPageSkipTabPage", {
		get: function () {
			return fiHub.state.bPSTP
		},
		set: function (v) {
			fiHub.state.bPSTP = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "brightness", {
		get: function() {
			return fiHub.state.bRn
		},
		set: function(v) {
			fiHub.state.bRn = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "carrierSheetClippingMode", {
		get: function () {
			return fiHub.state.cSCM
		},
		set: function (v) {
			fiHub.state.cSCM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "characterExtraction", {
		get: function () {
			return fiHub.state.cEx
		},
		set: function (v) {
			fiHub.state.cEx = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "characterExtractionMethod", {
		get: function () {
			return fiHub.state.cExM
		},
		set: function (v) {
			fiHub.state.cExM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "characterThickness", {
		get: function () {
			return fiHub.state.cTh
		},
		set: function (v) {
			fiHub.state.cTh = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "closeSourceUI", {
		get: function () {
			return fiHub.state.cSUI
		},
		set: function (v) {
			fiHub.state.cSUI = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "colorReproduction", {
		get: function () {
			return fiHub.state.cRe
		},
		set: function (v) {
			fiHub.state.cRe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "colorReproductionBrightness", {
		get: function () {
			return fiHub.state.cReB
		},
		set: function (v) {
			fiHub.state.cReB = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "colorReproductionContrast", {
		get: function () {
			return fiHub.state.cReC
		},
		set: function (v) {
			fiHub.state.cReC = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "colorReproductionCustomGamma", {
		get: function () {
			return fiHub.state.cReCG
		},
		set: function (v) {
			fiHub.state.cReCG = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "colorReproductionHighlight", {
		get: function () {
			return fiHub.state.cReH
		},
		set: function (v) {
			fiHub.state.cReH = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "colorReproductionShadow", {
		get: function () {
			return fiHub.state.cReS
		},
		set: function (v) {
			fiHub.state.cReS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "compressionType", {
		get: function () {
			return fiHub.state.cTy
		},
		set: function (v) {
			fiHub.state.cTy = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "contrast", {
		get: function () {
			return fiHub.state.cTr
		},
		set: function (v) {
			fiHub.state.cTr = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "cropMarginSize", {
		get: function () {
			return fiHub.state.cMS
		},
		set: function (v) {
			fiHub.state.cMS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "cropPriority", {
		get: function () {
			return fiHub.state.cPr
		},
		set: function (v) {
			fiHub.state.cPr = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "customGamma", {
		get: function () {
			return fiHub.state.cGa
		},
		set: function (v) {
			fiHub.state.cGa = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "customPaperLength", {
		get: function () {
			return fiHub.state.cPL
		},
		set: function (v) {
			fiHub.state.cPL = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "customPaperWidth", {
		get: function () {
			return fiHub.state.cPW
		},
		set: function (v) {
			fiHub.state.cPW = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "customResolution", {
		get: function () {
			return fiHub.state.cRti
		},
		set: function (v) {
			fiHub.state.cRti = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "deskew", {
		get: function () {
			return fiHub.state.dKe
		},
		set: function (v) {
			fiHub.state.dKe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "deskewBackground", {
		get: function () {
			return fiHub.state.dKeB
		},
		set: function (v) {
			fiHub.state.dKeB = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "deskewMode", {
		get: function () {
			return fiHub.state.dKeM
		},
		set: function (v) {
			fiHub.state.dKeM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorser", {
		get: function () {
			return fiHub.state.dEn
		},
		set: function (v) {
			fiHub.state.dEn = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorserCountDirection", {
		get: function () {
			return fiHub.state.dEnCD
		},
		set: function (v) {
			fiHub.state.dEnCD = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorserCounter", {
		get: function () {
			return fiHub.state.dEnC
		},
		set: function (v) {
			fiHub.state.dEnC = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorserCountStep", {
		get: function () {
			return fiHub.state.dEnCS
		},
		set: function (v) {
			fiHub.state.dEnCS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorserDirection", {
		get: function () {
			return fiHub.state.dEnDi
		},
		set: function (v) {
			fiHub.state.dEnDi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorserString", {
		get: function () {
			return fiHub.state.dEnS
		},
		set: function (v) {
			fiHub.state.dEnS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorserXOffset", {
		get: function () {
			return fiHub.state.dEnXO
		},
		set: function (v) {
			fiHub.state.dEnXO = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "digitalEndorserYOffset", {
		get: function () {
			return fiHub.state.dEnYO
		},
		set: function (v) {
			fiHub.state.dEnYO = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "divideLongPage", {
		get: function () {
			return fiHub.state.dLPa
		},
		set: function (v) {
			fiHub.state.dLPa = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "dTCSensitivity", {
		get: function () {
			return fiHub.state.dSe
		},
		set: function (v) {
			fiHub.state.dSe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "edgeFiller", {
		get: function () {
			return fiHub.state.eFi
		},
		set: function (v) {
			fiHub.state.eFi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "edgeFillerBottom", {
		get: function () {
			return fiHub.state.eFiB
		},
		set: function (v) {
			fiHub.state.eFiB = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "edgeFillerLeft", {
		get: function () {
			return fiHub.state.eFiL
		},
		set: function (v) {
			fiHub.state.eFiL = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "edgeFillerRight", {
		get: function () {
			return fiHub.state.eFiR
		},
		set: function (v) {
			fiHub.state.eFiR = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "edgeFillerTop", {
		get: function () {
			return fiHub.state.eFiT
		},
		set: function (v) {
			fiHub.state.eFiT = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "edgeRepair", {
		get: function () {
			return fiHub.state.eRe
		},
		set: function (v) {
			fiHub.state.eRe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorser", {
		get: function () {
			return fiHub.state.eSe
		},
		set: function (v) {
			fiHub.state.eSe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserCountDirection", {
		get: function () {
			return fiHub.state.eSeCD
		},
		set: function (v) {
			fiHub.state.eSeCD = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserCounter", {
		get: function () {
			return fiHub.state.eSeCt
		},
		set: function (v) {
			fiHub.state.eSeCt = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserCountStep", {
		get: function () {
			return fiHub.state.eSeCS
		},
		set: function (v) {
			fiHub.state.eSeCS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserDialog", {
		get: function () {
			return fiHub.state.eSeDg
		},
		set: function (v) {
			fiHub.state.eSeDg = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserDirection", {
		get: function () {
			return fiHub.state.eSeDt
		},
		set: function (v) {
			fiHub.state.eSeDt = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserFont", {
		get: function () {
			return fiHub.state.eSeF
		},
		set: function (v) {
			fiHub.state.eSeF = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserOffset", {
		get: function () {
			return fiHub.state.eSeO
		},
		set: function (v) {
			fiHub.state.eSeO = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "endorserString", {
		get: function () {
			return fiHub.state.eSeS
		},
		set: function (v) {
			fiHub.state.eSeS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "errorCode", {
		get: function () {
			return fiHub.state.eRCo
		},
	});
	Object.defineProperty(ricoh.fiscanner, "fadingCompensation", {
		get: function () {
			return fiHub.state.fCom
		},
		set: function (v) {
			fiHub.state.fCom = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounter", {
		get: function () {
			return fiHub.state.fCou
		},
		set: function (v) {
			fiHub.state.fCou = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounterEx", {
		get: function () {
			return fiHub.state.fCouEx
		},
		set: function (v) {
			fiHub.state.fCouEx = v
		}
	});
	var fNa = "";
	Object.defineProperty(ricoh.fiscanner, "fileName", {
		get: function () {
			return fNa
		},
		set: function (v) {
			fNa = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileType", {
		get: function () {
			return fiHub.state.fTy
		},
		set: function (v) {
			fiHub.state.fTy = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "filter", {
		get: function () {
			return fiHub.state.fIl
		},
		set: function (v) {
			fiHub.state.fIl = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "filterSaturationSensitivity", {
		get: function () {
			return fiHub.state.fIlSS
		},
		set: function (v) {
			fiHub.state.fIlSS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "frontBackDetection", {
		get: function () {
			return fiHub.state.fBD
		},
		set: function (v) {
			fiHub.state.fBD = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "frontBackMergingEnabled", {
		get: function () {
			return fiHub.state.fBME
		},
		set: function (v) {
			fiHub.state.fBME = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "frontBackMergingLocation", {
		get: function () {
			return fiHub.state.fBML
		},
		set: function (v) {
			fiHub.state.fBML = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "frontBackMergingRotation", {
		get: function () {
			return fiHub.state.fBMR
		},
		set: function (v) {
			fiHub.state.fBMR = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "frontBackMergingTarget", {
		get: function () {
			return fiHub.state.fBMT
		},
		set: function (v) {
			fiHub.state.fBMT = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "frontBackMergingTargetMode", {
		get: function () {
			return fiHub.state.fBMTM
		},
		set: function (v) {
			fiHub.state.fBMTM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "frontBackMergingTargetSize", {
		get: function () {
			return fiHub.state.fBMTS
		},
		set: function (v) {
			fiHub.state.fBMTS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "gamma", {
		get: function () {
			return fiHub.state.gAm
		},
		set: function (v) {
			fiHub.state.gAm = v
		}
	});
	var gFi = "";
	Object.defineProperty(ricoh.fiscanner, "gammaFile", {
		get: function () {
			return gFi
		},
		set: function (v) {
			gFi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "halftone", {
		get: function () {
			return fiHub.state.hTo
		},
		set: function (v) {
			fiHub.state.hTo = v
		}
	});
	var hFi = "";
	Object.defineProperty(ricoh.fiscanner, "halftoneFile", {
		get: function () {
			return hFi
		},
		set: function (v) {
			hFi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "highlight", {
		get: function () {
			return fiHub.state.hLi
		},
		set: function (v) {
			fiHub.state.hLi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "hwAutomaticDeskew", {
	    get: function () {
	        return fiHub.state.hADk
	    },
	    set: function (v) {
	        fiHub.state.hADk = v
	    }
	});
	Object.defineProperty(ricoh.fiscanner, "hwCompression", {
		get: function () {
			return fiHub.state.hCo
		},
		set: function (v) {
			fiHub.state.hCo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "hwMoireReductionMode", {
	    get: function () {
	        return fiHub.state.hMRm
	    },
	    set: function (v) {
	        fiHub.state.hMRm = v
	    }
	});
	Object.defineProperty(ricoh.fiscanner, "imageScanner", {
		get: function () {
			return fiHub.state.iSc
		}
	});
	Object.defineProperty(ricoh.fiscanner, "indicator", {
		get: function () {
			return fiHub.state.iNd
		},
		set: function (v) {
			fiHub.state.iNd = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "isExistsFB", {
		get: function () {
			return fiHub.state.iEFB
		}
	});
	Object.defineProperty(ricoh.fiscanner, "jobControl", {
		get: function () {
			return fiHub.state.jCo
		},
		set: function (v) {
			fiHub.state.jCo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "jobControlMode", {
		get: function () {
			return fiHub.state.jCoM
		},
		set: function (v) {
			fiHub.state.jCoM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "jpegQuality", {
		get: function () {
			return fiHub.state.jQt
		},
		set: function (v) {
			fiHub.state.jQt = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "lengthDetection", {
		get: function () {
			return fiHub.state.lDe
		},
		set: function (v) {
			fiHub.state.lDe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "longPage", {
		get: function () {
			return fiHub.state.lPa
		},
		set: function (v) {
			fiHub.state.lPa = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "manualFeedMode", {
		get: function () {
			return fiHub.state.mFM
		},
		set: function (v) {
			fiHub.state.mFM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "mRZType", {
		get: function () {
			return fiHub.state.mRZT
		},
		set: function (v) {
			fiHub.state.mRZT = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "multiFeed", {
		get: function () {
			return fiHub.state.mFe
		},
		set: function (v) {
			fiHub.state.mFe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "multiFeedNotice", {
		get: function () {
			return fiHub.state.mFeN
		},
		set: function (v) {
			fiHub.state.mFeN = v
		}
	});	
	Object.defineProperty(ricoh.fiscanner, "multiFeedModeChangeSize", {
		get: function () {
			return fiHub.state.mFeMCS
		},
		set: function (v) {
			fiHub.state.mFeMCS = v
		}
	});
	var mSDVM = "0"
	Object.defineProperty(ricoh.fiscanner, "multiStreamDefaultValueMode", {
		get: function () {
			return mSDVM
		},
		set: function (v) {
			mSDVM = v
		}
	});
	var mSFNM = "0"
	Object.defineProperty(ricoh.fiscanner, "multiStreamFileNameMode", {
		get: function () {
			return mSFNM
		},
		set: function (v) {
			mSFNM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "multiStreamMode", {
		get: function () {
			return fiHub.state.mSM
		},
		set: function (v) {
			fiHub.state.mSM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "noiseRejection", {
		get: function () {
			return fiHub.state.nRe
		},
		set: function (v) {
			fiHub.state.nRe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "orientation", {
		get: function () {
			return fiHub.state.oTa
		},
		set: function (v) {
			fiHub.state.oTa = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "overScan", {
		get: function () {
			return fiHub.state.oSc
		},
		set: function (v) {
			fiHub.state.oSc = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "overwrite", {
		get: function () {
			return fiHub.state.oWr
		},
		set: function (v) {
			fiHub.state.oWr = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "pageCount", {
		get: function () {
			return fiHub.state.pCo
		}
	});
	Object.defineProperty(ricoh.fiscanner, "paperProtection", {
		get: function () {
			return fiHub.state.pPr
		},
		set: function (v) {
			fiHub.state.pPr = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "paperSize", {
		get: function () {
			return fiHub.state.pSi
		},
		set: function (v) {
			fiHub.state.pSi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "paperSupply", {
		get: function () {
			return fiHub.state.pSu
		},
		set: function (v) {
			fiHub.state.pSu = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "passportDetection", {
		get: function () {
			return fiHub.state.pDe
		},
		set: function (v) {
			fiHub.state.pDe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "patchCodeDetection", {
		get: function () {
			return fiHub.state.pCDe
		},
		set: function (v) {
			fiHub.state.pCDe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "patchCodeDirection", {
		get: function () {
			return fiHub.state.pCDi
		},
		set: function (v) {
			fiHub.state.pCDi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "patchCodeType", {
		get: function () {
			return fiHub.state.pCTy
		},
		set: function (v) {
			fiHub.state.pCTy = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "patternRemoval", {
		get: function () {
			return fiHub.state.pRe
		},
		set: function (v) {
			fiHub.state.pRe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "pixelType", {
		get: function () {
			return fiHub.state.pTy
		},
		set: function (v) {
			fiHub.state.pTy = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "punchHoleRemoval", {
		get: function () {
			return fiHub.state.pHR
		},
		set: function (v) {
			fiHub.state.pHR = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "punchHoleRemovalMode", {
		get: function () {
			return fiHub.state.pHRM
		},
		set: function (v) {
			fiHub.state.pHRM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "regionLeft", {
		get: function () {
			return fiHub.state.rLef
		},
		set: function (v) {
			fiHub.state.rLef = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "regionLength", {
		get: function () {
			return fiHub.state.rLen
		},
		set: function (v) {
			fiHub.state.rLen = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "regionTop", {
		get: function () {
			return fiHub.state.rTo
		},
		set: function (v) {
			fiHub.state.rTo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "regionWidth", {
		get: function () {
			return fiHub.state.rWi
		},
		set: function (v) {
			fiHub.state.rWi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "resolution", {
		get: function () {
			return fiHub.state.rTi
		},
		set: function (v) {
			fiHub.state.rTi = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "reverse", {
		get: function () {
			return fiHub.state.rEv
		},
		set: function (v) {
			fiHub.state.rEv = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "rotation", {
		get: function () {
			return fiHub.state.rOt
		},
		set: function (v) {
			fiHub.state.rOt = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "scanContinue", {
		get: function () {
			return fiHub.state.sCu
		},
		set: function (v) {
			fiHub.state.sCu = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "scanContinueMode", {
		get: function () {
			return fiHub.state.sCuM
		},
		set: function (v) {
			fiHub.state.sCuM = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "scanCount", {
		get: function () {
			return fiHub.state.sCnt
		},
		set: function (v) {
			fiHub.state.sCnt = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "scanMode", {
		get: function () {
			return fiHub.state.sCMo
		},
		set: function (v) {
			fiHub.state.sCMo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "sDTCSensitivity", {
		get: function () {
			return fiHub.state.sDSe
		},
		set: function (v) {
			fiHub.state.sDSe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "sEE", {
		get: function () {
			return fiHub.state.sEE
		},
		set: function (v) {
			fiHub.state.sEE = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "selectOutputSize", {
		get: function () {
			return fiHub.state.sOS
		},
		set: function (v) {
			fiHub.state.sOS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "shadow", {
		get: function () {
			return fiHub.state.sHa
		},
		set: function (v) {
			fiHub.state.sHa = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "sharpness", {
		get: function () {
			return fiHub.state.sNe
		},
		set: function (v) {
			fiHub.state.sNe = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "showSourceUI", {
		get: function () {
			return fiHub.state.sSUI
		},
		set: function (v) {
			fiHub.state.sSUI = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "silentMode", {
		get: function () {
			return fiHub.state.sIMo
		},
		set: function (v) {
			fiHub.state.sIMo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "simpleSlicePatternRemoval", {
		get: function () {
			return fiHub.state.sSPP
		},
		set: function (v) {
			fiHub.state.sSPP = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "skipBlackPage", {
		get: function () {
			return fiHub.state.sBP
		},
		set: function (v) {
			fiHub.state.sBP = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "skipWhitePage", {
		get: function () {
			return fiHub.state.sWP
		},
		set: function (v) {
			fiHub.state.sWP = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "sourceCurrentScan", {
		get: function () {
			return fiHub.state.sCS
		},
		set: function (v) {
			fiHub.state.sCS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "stapleDetection", {
	    get: function () {
	        return fiHub.state.sDt
	    },
	    set: function (v) {
	        fiHub.state.sDt = v
	    }
	});
	Object.defineProperty(ricoh.fiscanner, "sRGB", {
		get: function () {
			return fiHub.state.sRGB
		},
		set: function (v) {
			fiHub.state.sRGB = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "synchronizationDigitalEndorser", {
		get: function () {
			return fiHub.state.sDEn
		},
		set: function (v) {
			fiHub.state.sDEn = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "threshold", {
		get: function () {
			return fiHub.state.tHo
		},
		set: function (v) {
			fiHub.state.tHo = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "twainDS", {
		get: function () {
			return fiHub.state.tDS
		},
		set: function (v) {
			fiHub.state.tDS = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "twainDSAnyPort", {
		get: function () {
			return fiHub.state.tDSAP
		},
		set: function (v) {
			fiHub.state.tDSAP = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "undefinedScanning", {
		get: function () {
			return fiHub.state.uSc
		},
		set: function (v) {
			fiHub.state.uSc = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "unit", {
		get: function () {
			return fiHub.state.unit
		},
		set: function (v) {
			fiHub.state.unit = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "verticalLineReduction", {
		get: function () {
			return fiHub.state.vLR
		},
		set: function (v) {
			fiHub.state.vLR = v
		}
	});
	var aRGB1;
	Object.defineProperty(ricoh.fiscanner, "adjustRGB1", {
		get: function () {
			return aRGB1
		},
		set: function (v) {
			aRGB1 = v
		}
	});
	var aRB1;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBB1", {
		get: function () {
			return aRB1
		},
		set: function (v) {
			aRB1 = v
		}
	});
	var aRG1;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBG1", {
		get: function () {
			return aRG1
		},
		set: function (v) {
			aRG1 = v
		}
	});
	var aRR1;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBR1", {
		get: function () {
			return aRR1
		},
		set: function (v) {
			aRR1 = v
		}
	});
	var aTho1;
	Object.defineProperty(ricoh.fiscanner, "aDTCThreshold1", {
		get: function () {
			return aTho1
		},
		set: function (v) {
			aTho1 = v
		}
	});
	var aBr1;
	Object.defineProperty(ricoh.fiscanner, "autoBright1", {
		get: function () {
			return aBr1
		},
		set: function (v) {
			aBr1 = v
		}
	});
	var bGr1;
	Object.defineProperty(ricoh.fiscanner, "background1", {
		get: function () {
			return bGr1
		},
		set: function (v) {
			bGr1 = v
		}
	});
	var bGrSi1;
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothing1", {
		get: function () {
			return bGrSi1
		},
		set: function (v) {
			bGrSi1 = v
		}
	});
	var bGrSn1;
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothness1", {
		get: function () {
			return bGrSn1
		},
		set: function (v) {
			bGrSn1 = v
		}
	});
	var bGrT1;
	Object.defineProperty(ricoh.fiscanner, "backgroundThreshold1", {
		get: function () {
			return bGrT1
		},
		set: function (v) {
			bGrT1 = v
		}
	});
	var bRn1;
	Object.defineProperty(ricoh.fiscanner, "brightness1", {
		get: function () {
			return bRn1
		},
		set: function (v) {
			bRn1 = v
		}
	});
	var cEx1;
	Object.defineProperty(ricoh.fiscanner, "characterExtraction1", {
		get: function () {
			return cEx1
		},
		set: function (v) {
			cEx1 = v
		}
	});
	var cExM1;
	Object.defineProperty(ricoh.fiscanner, "characterExtractionMethod1", {
		get: function () {
			return cExM1
		},
		set: function (v) {
			cExM1 = v
		}
	});
	var cTh1;
	Object.defineProperty(ricoh.fiscanner, "characterThickness1", {
		get: function () {
			return cTh1
		},
		set: function (v) {
			cTh1 = v
		}
	});
	var cRe1;
	Object.defineProperty(ricoh.fiscanner, "colorReproduction1", {
		get: function () {
			return cRe1
		},
		set: function (v) {
			cRe1 = v
		}
	});
	var cReB1;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionBrightness1", {
		get: function () {
			return cReB1
		},
		set: function (v) {
			cReB1 = v
		}
	});
	var cReC1;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionContrast1", {
		get: function () {
			return cReC1
		},
		set: function (v) {
			cReC1 = v
		}
	});
	var cReCG1;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionCustomGamma1", {
		get: function () {
			return cReCG1
		},
		set: function (v) {
			cReCG1 = v
		}
	});
	var cReH1;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionHighlight1", {
		get: function () {
			return cReH1
		},
		set: function (v) {
			cReH1 = v
		}
	});
	var cReS1;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionShadow1", {
		get: function () {
			return cReS1
		},
		set: function (v) {
			cReS1 = v
		}
	});
	var cTy1;
	Object.defineProperty(ricoh.fiscanner, "compressionType1", {
		get: function () {
			return cTy1
		},
		set: function (v) {
			cTy1 = v
		}
	});
	var cTr1;
	Object.defineProperty(ricoh.fiscanner, "contrast1", {
		get: function () {
			return cTr1
		},
		set: function (v) {
			cTr1 = v
		}
	});
	var cGa1;
	Object.defineProperty(ricoh.fiscanner, "customGamma1", {
		get: function () {
			return cGa1
		},
		set: function (v) {
			cGa1 = v
		}
	});
	var cRti1;
	Object.defineProperty(ricoh.fiscanner, "customResolution1", {
		get: function () {
			return cRti1
		},
		set: function (v) {
			cRti1 = v
		}
	});
	var dSe1;
	Object.defineProperty(ricoh.fiscanner, "dTCSensitivity1", {
		get: function () {
			return dSe1
		},
		set: function (v) {
			dSe1 = v
		}
	});
	var fCom1;
	Object.defineProperty(ricoh.fiscanner, "fadingCompensation1", {
		get: function () {
			return fCom1
		},
		set: function (v) {
			fCom1 = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounter1", {
		get: function () {
			return fiHub.state.fCou1
		},
		set: function (v) {
			fiHub.state.fCou1 = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounterEx1", {
		get: function () {
			return fiHub.state.fCouEx1
		},
		set: function (v) {
			fiHub.state.fCouEx1 = v
		}
	});
	var fNa1 = "";
	Object.defineProperty(ricoh.fiscanner, "fileName1", {
		get: function () {
			return fNa1
		},
		set: function (v) {
			fNa1 = v
		}
	});
	var fTy1;
	Object.defineProperty(ricoh.fiscanner, "fileType1", {
		get: function () {
			return fTy1
		},
		set: function (v) {
			fTy1 = v
		}
	});
	var fIl1;
	Object.defineProperty(ricoh.fiscanner, "filter1", {
		get: function () {
			return fIl1
		},
		set: function (v) {
			fIl1 = v
		}
	});
	var fIlSS1;
	Object.defineProperty(ricoh.fiscanner, "filterSaturationSensitivity1", {
		get: function () {
			return fIlSS1
		},
		set: function (v) {
			fIlSS1 = v
		}
	});
	var gAm1;
	Object.defineProperty(ricoh.fiscanner, "gamma1", {
		get: function () {
			return gAm1
		},
		set: function (v) {
			gAm1 = v
		}
	});
	var gFi1;
	Object.defineProperty(ricoh.fiscanner, "gammaFile1", {
		get: function () {
			return gFi1
		},
		set: function (v) {
			gFi1 = v
		}
	});
	var hTo1;
	Object.defineProperty(ricoh.fiscanner, "halftone1", {
		get: function () {
			return hTo1
		},
		set: function (v) {
			hTo1 = v
		}
	});
	var hFi1;
	Object.defineProperty(ricoh.fiscanner, "halftoneFile1", {
		get: function () {
			return hFi1
		},
		set: function (v) {
			hFi1 = v
		}
	});
	var hLi1;
	Object.defineProperty(ricoh.fiscanner, "highlight1", {
		get: function () {
			return hLi1
		},
		set: function (v) {
			hLi1 = v
		}
	});
	var nRe1;
	Object.defineProperty(ricoh.fiscanner, "noiseRejection1", {
		get: function () {
			return nRe1
		},
		set: function (v) {
			nRe1 = v
		}
	});
	var pRe1;
	Object.defineProperty(ricoh.fiscanner, "patternRemoval1", {
		get: function () {
			return pRe1
		},
		set: function (v) {
			pRe1 = v
		}
	});
	var pTy1;
	Object.defineProperty(ricoh.fiscanner, "pixelType1", {
		get: function () {
			return pTy1
		},
		set: function (v) {
			pTy1 = v
		}
	});
	var rTi1;
	Object.defineProperty(ricoh.fiscanner, "resolution1", {
		get: function () {
			return rTi1
		},
		set: function (v) {
			rTi1 = v
		}
	});
	var rEv1;
	Object.defineProperty(ricoh.fiscanner, "reverse1", {
		get: function () {
			return rEv1
		},
		set: function (v) {
			rEv1 = v
		}
	});
	var sDSe1;
	Object.defineProperty(ricoh.fiscanner, "sDTCSensitivity1", {
		get: function () {
			return sDSe1
		},
		set: function (v) {
			sDSe1 = v
		}
	});
	var sEE1;
	Object.defineProperty(ricoh.fiscanner, "sEE1", {
		get: function () {
			return sEE1
		},
		set: function (v) {
			sEE1 = v
		}
	});
	var sHa1;
	Object.defineProperty(ricoh.fiscanner, "shadow1", {
		get: function () {
			return sHa1
		},
		set: function (v) {
			sHa1 = v
		}
	});
	var sNe1;
	Object.defineProperty(ricoh.fiscanner, "sharpness1", {
		get: function () {
			return sNe1
		},
		set: function (v) {
			sNe1 = v
		}
	});
	var sSPP1;
	Object.defineProperty(ricoh.fiscanner, "simpleSlicePatternRemoval1", {
		get: function () {
			return sSPP1
		},
		set: function (v) {
			sSPP1 = v
		}
	});
	var sRGB1;
	Object.defineProperty(ricoh.fiscanner, "sRGB1", {
		get: function () {
			return sRGB1
		},
		set: function (v) {
			sRGB1 = v
		}
	});
	var tHo1;
	Object.defineProperty(ricoh.fiscanner, "threshold1", {
		get: function () {
			return tHo1
		},
		set: function (v) {
			tHo1 = v
		}
	});
	var aRGB2;
	Object.defineProperty(ricoh.fiscanner, "adjustRGB2", {
		get: function () {
			return aRGB2
		},
		set: function (v) {
			aRGB2 = v
		}
	});
	var aRB2;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBB2", {
		get: function () {
			return aRB2
		},
		set: function (v) {
			aRB2 = v
		}
	});
	var aRG2;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBG2", {
		get: function () {
			return aRG2
		},
		set: function (v) {
			aRG2 = v
		}
	});
	var aRR2;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBR2", {
		get: function () {
			return aRR2
		},
		set: function (v) {
			aRR2 = v
		}
	});
	var aTho2;
	Object.defineProperty(ricoh.fiscanner, "aDTCThreshold2", {
		get: function () {
			return aTho2
		},
		set: function (v) {
			aTho2 = v
		}
	});
	var aBr2;
	Object.defineProperty(ricoh.fiscanner, "autoBright2", {
		get: function () {
			return aBr2
		},
		set: function (v) {
			aBr2 = v
		}
	});
	var bGr2;
	Object.defineProperty(ricoh.fiscanner, "background2", {
		get: function () {
			return bGr2
		},
		set: function (v) {
			bGr2 = v
		}
	});
	var bGrSi2;
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothing2", {
		get: function () {
			return bGrSi2
		},
		set: function (v) {
			bGrSi2 = v
		}
	});
	var bGrSn2;
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothness2", {
		get: function () {
			return bGrSn2
		},
		set: function (v) {
			bGrSn2 = v
		}
	});
	var bGrT2;
	Object.defineProperty(ricoh.fiscanner, "backgroundThreshold2", {
		get: function () {
			return bGrT2
		},
		set: function (v) {
			bGrT2 = v
		}
	});
	var bRn2;
	Object.defineProperty(ricoh.fiscanner, "brightness2", {
		get: function () {
			return bRn2
		},
		set: function (v) {
			bRn2 = v
		}
	});
	var cEx2;
	Object.defineProperty(ricoh.fiscanner, "characterExtraction2", {
		get: function () {
			return cEx2
		},
		set: function (v) {
			cEx2 = v
		}
	});
	var cExM2;
	Object.defineProperty(ricoh.fiscanner, "characterExtractionMethod2", {
		get: function () {
			return cExM2
		},
		set: function (v) {
			cExM2 = v
		}
	});
	var cTh2;
	Object.defineProperty(ricoh.fiscanner, "characterThickness2", {
		get: function () {
			return cTh2
		},
		set: function (v) {
			cTh2 = v
		}
	});
	var cRe2;
	Object.defineProperty(ricoh.fiscanner, "colorReproduction2", {
		get: function () {
			return cRe2
		},
		set: function (v) {
			cRe2 = v
		}
	});
	var cReB2;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionBrightness2", {
		get: function () {
			return cReB2
		},
		set: function (v) {
			cReB2 = v
		}
	});
	var cReC2;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionContrast2", {
		get: function () {
			return cReC2
		},
		set: function (v) {
			cReC2 = v
		}
	});
	var cReCG2;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionCustomGamma2", {
		get: function () {
			return cReCG2
		},
		set: function (v) {
			cReCG2 = v
		}
	});
	var cReH2;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionHighlight2", {
		get: function () {
			return cReH2
		},
		set: function (v) {
			cReH2 = v
		}
	});
	var cReS2;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionShadow2", {
		get: function () {
			return cReS2
		},
		set: function (v) {
			cReS2 = v
		}
	});
	var cTy2;
	Object.defineProperty(ricoh.fiscanner, "compressionType2", {
		get: function () {
			return cTy2
		},
		set: function (v) {
			cTy2 = v
		}
	});
	var cTr2;
	Object.defineProperty(ricoh.fiscanner, "contrast2", {
		get: function () {
			return cTr2
		},
		set: function (v) {
			cTr2 = v
		}
	});
	var cGa2;
	Object.defineProperty(ricoh.fiscanner, "customGamma2", {
		get: function () {
			return cGa2
		},
		set: function (v) {
			cGa2 = v
		}
	});
	var cRti2;
	Object.defineProperty(ricoh.fiscanner, "customResolution2", {
		get: function () {
			return cRti2
		},
		set: function (v) {
			cRti2 = v
		}
	});
	var dSe2;
	Object.defineProperty(ricoh.fiscanner, "dTCSensitivity2", {
		get: function () {
			return dSe2
		},
		set: function (v) {
			dSe2 = v
		}
	});
	var fCom2;
	Object.defineProperty(ricoh.fiscanner, "fadingCompensation2", {
		get: function () {
			return fCom2
		},
		set: function (v) {
			fCom2 = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounter2", {
		get: function () {
			return fiHub.state.fCou2
		},
		set: function (v) {
			fiHub.state.fCou2 = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounterEx2", {
		get: function () {
			return fiHub.state.fCouEx2
		},
		set: function (v) {
			fiHub.state.fCouEx2 = v
		}
	});
	var fNa2 = "";
	Object.defineProperty(ricoh.fiscanner, "fileName2", {
		get: function () {
			return fNa2
		},
		set: function (v) {
			fNa2 = v
		}
	});
	var fTy2;
	Object.defineProperty(ricoh.fiscanner, "fileType2", {
		get: function () {
			return fTy2
		},
		set: function (v) {
			fTy2 = v
		}
	});
	var fIl2;
	Object.defineProperty(ricoh.fiscanner, "filter2", {
		get: function () {
			return fIl2
		},
		set: function (v) {
			fIl2 = v
		}
	});
	var fIlSS2;
	Object.defineProperty(ricoh.fiscanner, "filterSaturationSensitivity2", {
		get: function () {
			return fIlSS2
		},
		set: function (v) {
			fIlSS2 = v
		}
	});
	var gAm2;
	Object.defineProperty(ricoh.fiscanner, "gamma2", {
		get: function () {
			return gAm2
		},
		set: function (v) {
			gAm2 = v
		}
	});
	var gFi2;
	Object.defineProperty(ricoh.fiscanner, "gammaFile2", {
		get: function () {
			return gFi2
		},
		set: function (v) {
			gFi2 = v
		}
	});
	var hTo2;
	Object.defineProperty(ricoh.fiscanner, "halftone2", {
		get: function () {
			return hTo2
		},
		set: function (v) {
			hTo2 = v
		}
	});
	var hFi2;
	Object.defineProperty(ricoh.fiscanner, "halftoneFile2", {
		get: function () {
			return hFi2
		},
		set: function (v) {
			hFi2 = v
		}
	});
	var hLi2;
	Object.defineProperty(ricoh.fiscanner, "highlight2", {
		get: function () {
			return hLi2
		},
		set: function (v) {
			hLi2 = v
		}
	});
	var nRe2;
	Object.defineProperty(ricoh.fiscanner, "noiseRejection2", {
		get: function () {
			return nRe2
		},
		set: function (v) {
			nRe2 = v
		}
	});
	var pRe2;
	Object.defineProperty(ricoh.fiscanner, "patternRemoval2", {
		get: function () {
			return pRe2
		},
		set: function (v) {
			pRe2 = v
		}
	});
	var pTy2;
	Object.defineProperty(ricoh.fiscanner, "pixelType2", {
		get: function () {
			return pTy2
		},
		set: function (v) {
			pTy2 = v
		}
	});
	var rTi2;
	Object.defineProperty(ricoh.fiscanner, "resolution2", {
		get: function () {
			return rTi2
		},
		set: function (v) {
			rTi2 = v
		}
	});
	var rEv2;
	Object.defineProperty(ricoh.fiscanner, "reverse2", {
		get: function () {
			return rEv2
		},
		set: function (v) {
			rEv2 = v
		}
	});
	var sDSe2;
	Object.defineProperty(ricoh.fiscanner, "sDTCSensitivity2", {
		get: function () {
			return sDSe2
		},
		set: function (v) {
			sDSe2 = v
		}
	});
	var sEE2;
	Object.defineProperty(ricoh.fiscanner, "sEE2", {
		get: function () {
			return sEE2
		},
		set: function (v) {
			sEE2 = v
		}
	});
	var sHa2;
	Object.defineProperty(ricoh.fiscanner, "shadow2", {
		get: function () {
			return sHa2
		},
		set: function (v) {
			sHa2 = v
		}
	});
	var sNe2;
	Object.defineProperty(ricoh.fiscanner, "sharpness2", {
		get: function () {
			return sNe2
		},
		set: function (v) {
			sNe2 = v
		}
	});
	var sSPP2;
	Object.defineProperty(ricoh.fiscanner, "simpleSlicePatternRemoval2", {
		get: function () {
			return sSPP2
		},
		set: function (v) {
			sSPP2 = v
		}
	});
	var sRGB2;
	Object.defineProperty(ricoh.fiscanner, "sRGB2", {
		get: function () {
			return sRGB2
		},
		set: function (v) {
			sRGB2 = v
		}
	});
	var tHo2;
	Object.defineProperty(ricoh.fiscanner, "threshold2", {
		get: function () {
			return tHo2
		},
		set: function (v) {
			tHo2 = v
		}
	});
	var aRGB3;
	Object.defineProperty(ricoh.fiscanner, "adjustRGB3", {
		get: function () {
			return aRGB3
		},
		set: function (v) {
			aRGB3 = v
		}
	});
	var aRB3;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBB3", {
		get: function () {
			return aRB3
		},
		set: function (v) {
			aRB3 = v
		}
	});
	var aRG3;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBG3", {
		get: function () {
			return aRG3
		},
		set: function (v) {
			aRG3 = v
		}
	});
	var aRR3;
	Object.defineProperty(ricoh.fiscanner, "adjustRGBR3", {
		get: function () {
			return aRR3
		},
		set: function (v) {
			aRR3 = v
		}
	});
	var aTho3;
	Object.defineProperty(ricoh.fiscanner, "aDTCThreshold3", {
		get: function () {
			return aTho3
		},
		set: function (v) {
			aTho3 = v
		}
	});
	var aBr3;
	Object.defineProperty(ricoh.fiscanner, "autoBright3", {
		get: function () {
			return aBr3
		},
		set: function (v) {
			aBr3 = v
		}
	});
	var bGr3;
	Object.defineProperty(ricoh.fiscanner, "background3", {
		get: function () {
			return bGr3
		},
		set: function (v) {
			bGr3 = v
		}
	});
	var bGrSi3;
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothing3", {
		get: function () {
			return bGrSi3
		},
		set: function (v) {
			bGrSi3 = v
		}
	});
	var bGrSn3;
	Object.defineProperty(ricoh.fiscanner, "backgroundSmoothness3", {
		get: function () {
			return bGrSn3
		},
		set: function (v) {
			bGrSn3 = v
		}
	});
	var bGrT3;
	Object.defineProperty(ricoh.fiscanner, "backgroundThreshold3", {
		get: function () {
			return bGrT3
		},
		set: function (v) {
			bGrT3 = v
		}
	});
	var bRn3;
	Object.defineProperty(ricoh.fiscanner, "brightness3", {
		get: function () {
			return bRn3
		},
		set: function (v) {
			bRn3 = v
		}
	});
	var cEx3;
	Object.defineProperty(ricoh.fiscanner, "characterExtraction3", {
		get: function () {
			return cEx3
		},
		set: function (v) {
			cEx3 = v
		}
	});
	var cExM3;
	Object.defineProperty(ricoh.fiscanner, "characterExtractionMethod3", {
		get: function () {
			return cExM3
		},
		set: function (v) {
			cExM3 = v
		}
	});
	var cTh3;
	Object.defineProperty(ricoh.fiscanner, "characterThickness3", {
		get: function () {
			return cTh3
		},
		set: function (v) {
			cTh3 = v
		}
	});
	var cRe3;
	Object.defineProperty(ricoh.fiscanner, "colorReproduction3", {
		get: function () {
			return cRe3
		},
		set: function (v) {
			cRe3 = v
		}
	});
	var cReB3;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionBrightness3", {
		get: function () {
			return cReB3
		},
		set: function (v) {
			cReB3 = v
		}
	});
	var cReC3;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionContrast3", {
		get: function () {
			return cReC3
		},
		set: function (v) {
			cReC3 = v
		}
	});
	var cReCG3;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionCustomGamma3", {
		get: function () {
			return cReCG3
		},
		set: function (v) {
			cReCG3 = v
		}
	});
	var cReH3;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionHighlight3", {
		get: function () {
			return cReH3
		},
		set: function (v) {
			cReH3 = v
		}
	});
	var cReS3;
	Object.defineProperty(ricoh.fiscanner, "colorReproductionShadow3", {
		get: function () {
			return cReS3
		},
		set: function (v) {
			cReS3 = v
		}
	});
	var cTy3;
	Object.defineProperty(ricoh.fiscanner, "compressionType3", {
		get: function () {
			return cTy3
		},
		set: function (v) {
			cTy3 = v
		}
	});
	var cTr3;
	Object.defineProperty(ricoh.fiscanner, "contrast3", {
		get: function () {
			return cTr3
		},
		set: function (v) {
			cTr3 = v
		}
	});
	var cGa3;
	Object.defineProperty(ricoh.fiscanner, "customGamma3", {
		get: function () {
			return cGa3
		},
		set: function (v) {
			cGa3 = v
		}
	});
	var cRti3;
	Object.defineProperty(ricoh.fiscanner, "customResolution3", {
		get: function () {
			return cRti3
		},
		set: function (v) {
			cRti3 = v
		}
	});
	var dSe3;
	Object.defineProperty(ricoh.fiscanner, "dTCSensitivity3", {
		get: function () {
			return dSe3
		},
		set: function (v) {
			dSe3 = v
		}
	});
	var fCom3;
	Object.defineProperty(ricoh.fiscanner, "fadingCompensation3", {
		get: function () {
			return fCom3
		},
		set: function (v) {
			fCom3 = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounter3", {
		get: function () {
			return fiHub.state.fCou3
		},
		set: function (v) {
			fiHub.state.fCou3 = v
		}
	});
	Object.defineProperty(ricoh.fiscanner, "fileCounterEx3", {
		get: function () {
			return fiHub.state.fCouEx3
		},
		set: function (v) {
			fiHub.state.fCouEx3 = v
		}
	});
	var fNa3 = "";
	Object.defineProperty(ricoh.fiscanner, "fileName3", {
		get: function () {
			return fNa3
		},
		set: function (v) {
			fNa3 = v
		}
	});
	var fTy3;
	Object.defineProperty(ricoh.fiscanner, "fileType3", {
		get: function () {
			return fTy3
		},
		set: function (v) {
			fTy3 = v
		}
	});
	var fIl3;
	Object.defineProperty(ricoh.fiscanner, "filter3", {
		get: function () {
			return fIl3
		},
		set: function (v) {
			fIl3 = v
		}
	});
	var fIlSS3;
	Object.defineProperty(ricoh.fiscanner, "filterSaturationSensitivity3", {
		get: function () {
			return fIlSS3
		},
		set: function (v) {
			fIlSS3 = v
		}
	});
	var gAm3;
	Object.defineProperty(ricoh.fiscanner, "gamma3", {
		get: function () {
			return gAm3
		},
		set: function (v) {
			gAm3 = v
		}
	});
	var gFi3;
	Object.defineProperty(ricoh.fiscanner, "gammaFile3", {
		get: function () {
			return gFi3
		},
		set: function (v) {
			gFi3 = v
		}
	});
	var hTo3;
	Object.defineProperty(ricoh.fiscanner, "halftone3", {
		get: function () {
			return hTo3
		},
		set: function (v) {
			hTo3 = v
		}
	});
	var hFi3;
	Object.defineProperty(ricoh.fiscanner, "halftoneFile3", {
		get: function () {
			return hFi3
		},
		set: function (v) {
			hFi3 = v
		}
	});
	var hLi3;
	Object.defineProperty(ricoh.fiscanner, "highlight3", {
		get: function () {
			return hLi3
		},
		set: function (v) {
			hLi3 = v
		}
	});
	var nRe3;
	Object.defineProperty(ricoh.fiscanner, "noiseRejection3", {
		get: function () {
			return nRe3
		},
		set: function (v) {
			nRe3 = v
		}
	});
	var pRe3;
	Object.defineProperty(ricoh.fiscanner, "patternRemoval3", {
		get: function () {
			return pRe3
		},
		set: function (v) {
			pRe3 = v
		}
	});
	var pTy3;
	Object.defineProperty(ricoh.fiscanner, "pixelType3", {
		get: function () {
			return pTy3
		},
		set: function (v) {
			pTy3 = v
		}
	});
	var rTi3;
	Object.defineProperty(ricoh.fiscanner, "resolution3", {
		get: function () {
			return rTi3
		},
		set: function (v) {
			rTi3 = v
		}
	});
	var rEv3;
	Object.defineProperty(ricoh.fiscanner, "reverse3", {
		get: function () {
			return rEv3
		},
		set: function (v) {
			rEv3 = v
		}
	});
	var sDSe3;
	Object.defineProperty(ricoh.fiscanner, "sDTCSensitivity3", {
		get: function () {
			return sDSe3
		},
		set: function (v) {
			sDSe3 = v
		}
	});
	var sEE3;
	Object.defineProperty(ricoh.fiscanner, "sEE3", {
		get: function () {
			return sEE3
		},
		set: function (v) {
			sEE3 = v
		}
	});
	var sHa3;
	Object.defineProperty(ricoh.fiscanner, "shadow3", {
		get: function () {
			return sHa3
		},
		set: function (v) {
			sHa3 = v
		}
	});
	var sNe3;
	Object.defineProperty(ricoh.fiscanner, "sharpness3", {
		get: function () {
			return sNe3
		},
		set: function (v) {
			sNe3 = v
		}
	});
	var sSPP3;
	Object.defineProperty(ricoh.fiscanner, "simpleSlicePatternRemoval3", {
		get: function () {
			return sSPP3
		},
		set: function (v) {
			sSPP3 = v
		}
	});
	var sRGB3;
	Object.defineProperty(ricoh.fiscanner, "sRGB3", {
		get: function () {
			return sRGB3
		},
		set: function (v) {
			sRGB3 = v
		}
	});
	var tHo3;
	Object.defineProperty(ricoh.fiscanner, "threshold3", {
		get: function () {
			return tHo3
		},
		set: function (v) {
			tHo3 = v
		}
	});

	var fiHub;
	var convertToBase64;
	var convertToBase64Ex;
	var convertToBlob;
	var deleteFile;
	var deleteFileEx;

	function $() {
		console.log("initiate.js library is called.");
	}

	function Initialize(c) {
		fiHub = c;
		fiHub.client.onConnected = function(id) {
			console.log("Establish a connection with the server" + " |" + id);
			if (typeof (eval(fiHub.client.OnScannerReady)) == "function") {
				console.log("fiHub.client.OnScannerReady defined");
				fiHub.client.OnScannerReady();
			}
			else {
				console.log("fiHub.client.OnScannerReady undefined");
			}
		}
		c.client.OnConvertToBase64 = OnConvertToBase64Adpter;
		c.client.OnConvertToBlob = OnConvertToBlobAdpter;
		c.client.OnDeleteFile = OnDeleteFileAdpter;
		c.client.OnConvertToBase64Ex = OnConvertToBase64ExAdpter;
		c.client.OnDeleteFileEx = OnDeleteFileExAdpter;
	}

	function SetTwainDSInfo() {
		console.info("SetTwainDSInfo start");
		return fiHub.server.setTwainDSInfo();
	}

	function SetSourceCurrentScan() {
		console.info("SetSourceCurrentScan start");
		return fiHub.server.setSourceCurrentScan();
	}

	function OpenScanner() {
		console.info("OpenScanner start");
		return fiHub.server.openScanner();
	}

	function OpenScanner2() {
		console.info("OpenScanner2 start");
		return fiHub.server.openScanner2();
	}

	function SelectSource() {
		console.info("SelectSource start");
		return fiHub.server.selectSource();
	}

	function StartScan() {
		console.info("StartScan start");

		var propertyObj = {};
		propertyObj.FileName = fNa;
		propertyObj.GammaFile = gFi;
		propertyObj.HalftoneFile = hFi;
		propertyObj.MultiStreamDefaultValueMode = mSDVM;
		propertyObj.MultiStreamFileNameMode = mSFNM;
		propertyObj.AdjustRGB1 = aRGB1;
		propertyObj.AdjustRGBB1 = aRB1;
		propertyObj.AdjustRGBG1 = aRG1;
		propertyObj.AdjustRGBR1 = aRR1;
		propertyObj.ADTCThreshold1 = aTho1;
		propertyObj.AutoBright1 = aBr1;
		propertyObj.Background1 = bGr1;
		propertyObj.BackgroundSmoothing1 = bGrSi1;
		propertyObj.BackgroundSmoothness1 = bGrSn1;
		propertyObj.BackgroundThreshold1 = bGrT1;
		propertyObj.Brightness1 = bRn1;
		propertyObj.CharacterExtraction1 = cEx1;
		propertyObj.CharacterExtractionMethod1 = cExM1;
		propertyObj.CharacterThickness1 = cTh1;
		propertyObj.ColorReproduction1 = cRe1;
		propertyObj.ColorReproductionBrightness1 = cReB1;
		propertyObj.ColorReproductionContrast1 = cReC1;
		propertyObj.ColorReproductionCustomGamma1 = cReCG1;
		propertyObj.ColorReproductionHighlight1 = cReH1;
		propertyObj.ColorReproductionShadow1 = cReS1;
		propertyObj.CompressionType1 = cTy1;
		propertyObj.Contrast1 = cTr1;
		propertyObj.CustomGamma1 = cGa1;
		propertyObj.CustomResolution1 = cRti1;
		propertyObj.DTCSensitivity1 = dSe1;
		propertyObj.FadingCompensation1 = fCom1;
		propertyObj.FileName1 = fNa1;
		propertyObj.FileType1 = fTy1;
		propertyObj.Filter1 = fIl1;
		propertyObj.FilterSaturationSensitivity1 = fIlSS1;
		propertyObj.Gamma1 = gAm1;
		propertyObj.GammaFile1 = gFi1;
		propertyObj.Halftone1 = hTo1;
		propertyObj.HalftoneFile1 = hFi1;
		propertyObj.Highlight1 = hLi1;
		propertyObj.NoiseRejection1 = nRe1;
		propertyObj.PatternRemoval1 = pRe1;
		propertyObj.PixelType1 = pTy1;
		propertyObj.Resolution1 = rTi1;
		propertyObj.Reverse1 = rEv1;
		propertyObj.SDTCSensitivity1 = sDSe1;
		propertyObj.SEE1 = sEE1;
		propertyObj.Shadow1 = sHa1;
		propertyObj.Sharpness1 = sNe1;
		propertyObj.SimpleSlicePatternRemoval1 = sSPP1;
		propertyObj.sRGB1 = sRGB1;
		propertyObj.Threshold1 = tHo1;

		propertyObj.AdjustRGB2 = aRGB2;
		propertyObj.AdjustRGBB2 = aRB2;
		propertyObj.AdjustRGBG2 = aRG2;
		propertyObj.AdjustRGBR2 = aRR2;
		propertyObj.ADTCThreshold2 = aTho2;
		propertyObj.AutoBright2 = aBr2;
		propertyObj.Background2 = bGr2;
		propertyObj.BackgroundSmoothing2 = bGrSi2;
		propertyObj.BackgroundSmoothness2 = bGrSn2;
		propertyObj.BackgroundThreshold2 = bGrT2;
		propertyObj.Brightness2 = bRn2;
		propertyObj.CharacterExtraction2 = cEx2;
		propertyObj.CharacterExtractionMethod2 = cExM2;
		propertyObj.CharacterThickness2 = cTh2;
		propertyObj.ColorReproduction2 = cRe2;
		propertyObj.ColorReproductionBrightness2 = cReB2;
		propertyObj.ColorReproductionContrast2 = cReC2;
		propertyObj.ColorReproductionCustomGamma2 = cReCG2;
		propertyObj.ColorReproductionHighlight2 = cReH2;
		propertyObj.ColorReproductionShadow2 = cReS2;
		propertyObj.CompressionType2 = cTy2;
		propertyObj.Contrast2 = cTr2;
		propertyObj.CustomGamma2 = cGa2;
		propertyObj.CustomResolution2 = cRti2;
		propertyObj.DTCSensitivity2 = dSe2;
		propertyObj.FadingCompensation2 = fCom2;
		propertyObj.FileName2 = fNa2;
		propertyObj.FileType2 = fTy2;
		propertyObj.Filter2 = fIl2;
		propertyObj.FilterSaturationSensitivity2 = fIlSS2;
		propertyObj.Gamma2 = gAm2;
		propertyObj.GammaFile2 = gFi2;
		propertyObj.Halftone2 = hTo2;
		propertyObj.HalftoneFile2 = hFi2;
		propertyObj.Highlight2 = hLi2;
		propertyObj.NoiseRejection2 = nRe2;
		propertyObj.PatternRemoval2 = pRe2;
		propertyObj.PixelType2 = pTy2;
		propertyObj.Resolution2 = rTi2;
		propertyObj.Reverse2 = rEv2;
		propertyObj.SDTCSensitivity2 = sDSe2;
		propertyObj.SEE2 = sEE2;
		propertyObj.Shadow2 = sHa2;
		propertyObj.Sharpness2 = sNe2;
		propertyObj.SimpleSlicePatternRemoval2 = sSPP2;
		propertyObj.sRGB2 = sRGB2;
		propertyObj.Threshold2 = tHo2;

		propertyObj.AdjustRGB3 = aRGB3;
		propertyObj.AdjustRGBB3 = aRB3;
		propertyObj.AdjustRGBG3 = aRG3;
		propertyObj.AdjustRGBR3 = aRR3;
		propertyObj.ADTCThreshold3 = aTho3;
		propertyObj.AutoBright3 = aBr3;
		propertyObj.Background3 = bGr3;
		propertyObj.BackgroundSmoothing3 = bGrSi3;
		propertyObj.BackgroundSmoothness3 = bGrSn3;
		propertyObj.BackgroundThreshold3 = bGrT3;
		propertyObj.Brightness3 = bRn3;
		propertyObj.CharacterExtraction3 = cEx3;
		propertyObj.CharacterExtractionMethod3 = cExM3;
		propertyObj.CharacterThickness3 = cTh3;
		propertyObj.ColorReproduction3 = cRe3;
		propertyObj.ColorReproductionBrightness3 = cReB3;
		propertyObj.ColorReproductionContrast3 = cReC3;
		propertyObj.ColorReproductionCustomGamma3 = cReCG3;
		propertyObj.ColorReproductionHighlight3 = cReH3;
		propertyObj.ColorReproductionShadow3 = cReS3;
		propertyObj.CompressionType3 = cTy3;
		propertyObj.Contrast3 = cTr3;
		propertyObj.CustomGamma3 = cGa3;
		propertyObj.CustomResolution3 = cRti3;
		propertyObj.DTCSensitivity3 = dSe3;
		propertyObj.FadingCompensation3 = fCom3;
		propertyObj.FileName3 = fNa3;
		propertyObj.FileType3 = fTy3;
		propertyObj.Filter3 = fIl3;
		propertyObj.FilterSaturationSensitivity3 = fIlSS3;
		propertyObj.Gamma3 = gAm3;
		propertyObj.GammaFile3 = gFi3;
		propertyObj.Halftone3 = hTo3;
		propertyObj.HalftoneFile3 = hFi3;
		propertyObj.Highlight3 = hLi3;
		propertyObj.NoiseRejection3 = nRe3;
		propertyObj.PatternRemoval3 = pRe3;
		propertyObj.PixelType3 = pTy3;
		propertyObj.Resolution3 = rTi3;
		propertyObj.Reverse3 = rEv3;
		propertyObj.SDTCSensitivity3 = sDSe3;
		propertyObj.SEE3 = sEE3;
		propertyObj.Shadow3 = sHa3;
		propertyObj.Sharpness3 = sNe3;
		propertyObj.SimpleSlicePatternRemoval3 = sSPP3;
		propertyObj.sRGB3 = sRGB3;
		propertyObj.Threshold3 = tHo3;

		var jsonProperty = JSON.stringify(propertyObj);
		return fiHub.server.startScan(jsonProperty);
	}

	function CloseScanner() {
		console.info("CloseScanner start");
		return fiHub.server.closeScanner();
	}
	
	function GetSourceCount() {
		console.info("GetSourceCount start");
		return fiHub.server.getSourceCount();
	}

	function GetTWAINTemplateCount() {
		console.info("GetTWAINTemplateCount start");
		return fiHub.server.getTWAINTemplateCount();
	}
	
	function GetSourceName(i) {
		console.info("GetSourceName start " + i);
		return fiHub.server.getSourceName(i);
	}

	function GetTWAINTemplateName(i) {
		console.info("GetTWAINTemplateName start " + i);
		return fiHub.server.getTWAINTemplateName(i);
	}

	function GetSourceSelect() {
		console.info("GetSourceSelect start");
		return fiHub.server.getSourceSelect();
	}

	function SetupDataSourceProperties() {
		console.info("SetupDataSourceProperties start");
		return fiHub.server.setupDataSourceProperties();
	}

	function GetTWAINTemplateSelect() {
		console.info("GetTWAINTemplateSelect start");
		return fiHub.server.getTWAINTemplateSelect();
	}

	function SelectSourceName(n) {
		console.info("SelectSourceName start");
		return fiHub.server.selectSourceName(n);
	}

	function SetTWAINTemplateSelect(n) {
		console.info("SetTWAINTemplateSelect start");
		return fiHub.server.setTWAINTemplateSelect(n);
	}

	function RegisterEvent(n, f) {
		console.info("RegisterEvent start");
		if (n == "OnScannerReady") {
			fiHub.client.OnScannerReady = f;
		}
		else if (n == "OnScanToFile") {
			fiHub.client.OnScanToFile = f;
		}
		else if (n == "OnDetectBarcode") {
			fiHub.client.OnDetectBarcode = f;
		}
		else if (n == "OnDetectBarcodeDetail") {
			fiHub.client.OnDetectBarcodeDetail = f;
		}
		else if (n == "OnDetectPatchCode") {
			fiHub.client.OnDetectPatchCode = f;
		}
		else if (n == "OnDetectJobSeparator") {
			fiHub.client.OnDetectJobSeparator = f;
		}
		else if (n == "OnAIQCResult") {
			fiHub.client.OnAIQCResult = f;
		}
		else if (n == "OnBlankPageResult") {
			fiHub.client.OnBlankPageResult = f;
		}
		else if (n == "OnMultiFeedResult") {
			fiHub.client.OnMultiFeedResult = f;
		}
		else if (n == "OnPageNumber") {
			fiHub.client.OnPageNumber = f;
		}
		else if (n == "OnAutoProfileSelection") {
			fiHub.client.OnAutoProfileSelection = f;
		}
		else if (n == "OnPagePartition") {
			fiHub.client.OnPagePartition = f;
		}
		else if (n == "OnDetectPassport") {
			fiHub.client.OnDetectPassport = f;
		}
		else if (n == "OnDetectPassportEx") {
			fiHub.client.OnDetectPassportEx = f;
		}
	}
	
	function ConvertToBase64(d, e) {
		convertToBase64 = e;
		fiHub.server.convertToBase64(d);
	}
	
	function OnConvertToBase64Adpter(r, d) {
		console.info("OnConvertToBase64 " + r);
		convertToBase64(r,d);
	}
	
	function ConvertToBlob(d, e) {
		convertToBlob = e;
		fiHub.server.convertToBlob(d);
	}
	
	function OnConvertToBlobAdpter(r, d) {
		console.info("OnConvertToBlob " + r);
		convertToBlob(r,d);
	}

	function DeleteFile(d, e) {
		deleteFile = e;
		fiHub.server.deleteFile(d);
	}

	function OnDeleteFileAdpter(r) {
		console.info("OnDeleteFile " + r);
		deleteFile(r);
	}

	function ConvertToBase64Ex(d, a, e) {
		convertToBase64Ex = e;
		fiHub.server.convertToBase64Ex(d, a);
	}
	
	function OnConvertToBase64ExAdpter(r, f, a, d) {
		console.info("OnConvertToBase64Ex " + r);
		convertToBase64Ex(r, f, a, d);
	}

	function DeleteFileEx(d, e) {
		deleteFileEx = e;
		fiHub.server.deleteFileEx(d);
	}

	function OnDeleteFileExAdpter(r, f) {
		console.info("OnDeleteFileEx " + r);
		deleteFileEx(r, f);
	}

	function ClearPage() {
		console.info("ClearPage start");
		return fiHub.server.clearPage();
	}

	function FeederLoaded() {
		console.info("FeederLoaded start");
		return fiHub.server.feederLoaded();
	}

	function ScannerAvailable() {
		console.info("ScannerAvailable start");
		return fiHub.server.scannerAvailable();
	}

	function SetTopMostWindow(b) {
		console.info("SetTopMostWindow start");
		fiHub.server.setTopMostWindow(b);
	}

	function GetSerialNumber() {
		console.info("GetSerialNumber start ");
		return fiHub.server.getSerialNumber();
	}

	window['ricoh']['fiscanner']['$'] = $;
	window['ricoh']['fiscanner']['Initialize'] = Initialize;
	window['ricoh']['fiscanner']['RegisterEvent'] = RegisterEvent;
	window['ricoh']['fiscanner']['ConvertToBlob'] = ConvertToBlob;
	window['ricoh']['fiscanner']['ConvertToBase64'] = ConvertToBase64;
	window['ricoh']['fiscanner']['ConvertToBase64Ex'] = ConvertToBase64Ex;
	window['ricoh']['fiscanner']['DeleteFile'] = DeleteFile;
	window['ricoh']['fiscanner']['DeleteFileEx'] = DeleteFileEx;
	window['ricoh']['fiscanner']['SetTwainDSInfo'] = SetTwainDSInfo;
	window['ricoh']['fiscanner']['SetSourceCurrentScan'] = SetSourceCurrentScan;
	window['ricoh']['fiscanner']['OpenScanner'] = OpenScanner;
	window['ricoh']['fiscanner']['OpenScanner2'] = OpenScanner2;
	window['ricoh']['fiscanner']['SelectSource'] = SelectSource;
	window['ricoh']['fiscanner']['StartScan'] = StartScan;
	window['ricoh']['fiscanner']['CloseScanner'] = CloseScanner;
	window['ricoh']['fiscanner']['GetSourceCount'] = GetSourceCount;
	window['ricoh']['fiscanner']['GetSourceName'] = GetSourceName;
	window['ricoh']['fiscanner']['GetSourceSelect'] = GetSourceSelect;
	window['ricoh']['fiscanner']['SetupDataSourceProperties'] = SetupDataSourceProperties;
	window['ricoh']['fiscanner']['SelectSourceName'] = SelectSourceName;
	window['ricoh']['fiscanner']['GetTWAINTemplateCount'] = GetTWAINTemplateCount;
	window['ricoh']['fiscanner']['GetTWAINTemplateName'] = GetTWAINTemplateName;
	window['ricoh']['fiscanner']['GetTWAINTemplateSelect'] = GetTWAINTemplateSelect;
	window['ricoh']['fiscanner']['SetTWAINTemplateSelect'] = SetTWAINTemplateSelect;
	window['ricoh']['fiscanner']['ClearPage'] = ClearPage;
	window['ricoh']['fiscanner']['FeederLoaded'] = FeederLoaded;
	window['ricoh']['fiscanner']['ScannerAvailable'] = ScannerAvailable;
	window['ricoh']['fiscanner']['SetTopMostWindow'] = SetTopMostWindow;
	window['ricoh']['fiscanner']['GetSerialNumber'] = GetSerialNumber;

})();